import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useApp } from '../context/AppContext';
import { MapPin, Clock, Navigation, Building2, KeyRound } from 'lucide-react';

const STEPS = [
  { img: '/guide/guide-1.jpg', fr: 'Entrez dans le bâtiment Metio (Route de la Corniche 2).', en: 'Enter the Metio building (Route de la Corniche 2).' },
  { img: '/guide/guide-2.jpg', fr: 'Descendez au niveau -1 (ascenseur ou escalier).', en: 'Go down to floor -1 (lift or stairs).' },
  { img: '/guide/guide-3.jpg', fr: 'Au -1, allez côté sud (côté lac), vers la porte du parking.', en: 'On -1, head to the south / lake side, towards the parking door.' },
  { img: '/guide/guide-4.jpg', fr: 'La salle de convivialité est sur votre droite (C 04 – 012).', en: 'The salle de convivialité is on your right (C 04 – 012).' },
  { img: '/guide/guide-5.jpg', fr: "Entrez le code d'accès — le même que les autres codes du campus.", en: 'Enter the access code — the same as the other campus codes.' },
];

export default function FridgesPage() {
  const { t, tf, lang, fridges: FRIDGES } = useApp();
  return (
    <div className="min-h-screen bg-[#faf9f5]">
      <Header />
      <section className="bg-[#4b5e34] text-white">
        <div className="max-w-[1280px] mx-auto px-5 py-14">
          <h1 className="font-display text-[42px] leading-tight mb-2">{t('fridges_title')}</h1>
          <p className="text-[#d8dcc6] text-lg max-w-2xl">{t('fridges_sub')}</p>
        </div>
      </section>

      <main className="max-w-[1280px] mx-auto px-5 py-12">
        {FRIDGES.map((f) => (
          <div key={f.id} data-testid="fridge-location-card" className="bg-white rounded-2xl border border-neutral-200 overflow-hidden md:flex">
            <div className="md:w-1/2 h-64 md:h-auto bg-neutral-100">
              <iframe
                title={f.name}
                className="w-full h-full border-0"
                loading="lazy"
                src={`https://www.google.com/maps?q=${encodeURIComponent(f.address)}&output=embed`}
              />
            </div>
            <div className="p-6 md:w-1/2">
              <h3 className="font-display text-2xl text-[#2f3826] mb-3">{f.name}</h3>
              <p className="flex items-start gap-2 text-sm text-neutral-600 mb-1.5"><MapPin size={16} className="text-[#b8863b] mt-0.5 shrink-0" /> {f.address}</p>
              <p className="flex items-center gap-2 text-sm text-neutral-600 mb-1.5"><Clock size={16} className="text-[#b8863b] shrink-0" /> {t('hours')}: {f.hours}</p>
              {f.floor && <p className="flex items-center gap-2 text-sm text-neutral-600 mb-1.5"><Building2 size={16} className="text-[#b8863b] shrink-0" /> {t('floor_label')}: {f.floor}</p>}
              {f.instructions && tf(f.instructions) && (
                <p className="flex items-start gap-2 text-sm text-neutral-600 mb-4"><KeyRound size={16} className="text-[#b8863b] mt-0.5 shrink-0" /> {tf(f.instructions)}</p>
              )}
              <a
                href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(f.address)}`}
                target="_blank" rel="noreferrer"
                className="inline-flex items-center gap-2 text-sm font-medium text-[#4b5e34] bg-[#eef0e6] hover:bg-[#e4ddcb] px-4 py-2 rounded-lg transition-colors"
              >
                <Navigation size={15} /> {t('directions')}
              </a>
            </div>
          </div>
        ))}

        <div className="mt-12">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-1.5 h-9 rounded-full bg-[#4b5e34]" />
            <h2 data-testid="fridge-guide-title" className="font-display text-[26px] text-[#2f3826]">
              {lang === 'fr' ? 'Comment accéder au frigo' : 'How to reach the fridge'}
            </h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {STEPS.map((s, i) => (
              <div key={s.img} data-testid={`fridge-guide-step-${i + 1}`} className="bg-white rounded-xl border border-neutral-200 overflow-hidden">
                <img src={s.img} alt={lang === 'fr' ? s.fr : s.en} className="w-full aspect-[3/4] object-cover" />
                <div className="p-3 flex items-start gap-2">
                  <span className="w-6 h-6 shrink-0 rounded-full bg-[#4b5e34] text-white text-xs font-bold flex items-center justify-center">{i + 1}</span>
                  <p className="text-xs text-neutral-600 leading-snug">{lang === 'fr' ? s.fr : s.en}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
